export default __webpack_public_path__ + "static/media/AutotracLogo.ebf69720.png";